import { useCorporate } from "@/context/CorporateGroupContext";
import { fullResetDiagnosis } from "@/stores/features/diagnosisSlice";
import {
  setCompanyInfoCollapse,
  setDiagnosisCurrent,
  setStepsLenght,
} from "@/stores/features/utilsSlice";
import { useAppDispatch, useAppSelector } from "@/stores/hooks";
import { companyService } from "@/stores/services/companyService";
import { decryptId } from "@/utils/utilsMethods";
import { skipToken } from "@reduxjs/toolkit/query";
import { Breadcrumb, Steps } from "antd";
import { useEffect, useMemo } from "react";
import { FaClipboardCheck } from "react-icons/fa";
import { MdAccountTree, MdOutlineCloudDownload } from "react-icons/md";
import { useParams, useSearchParams } from "react-router-dom";
import CompanyInfo from "./Components/CompanyInfo";
import DiagnosisForm from "./Components/Steps/DiagnosisForm";
import DownLoadReport from "./Components/Steps/DownLoadReport";
import QuantityForm from "./Components/Steps/QuantityForm";
import { BreadcrumbItems } from "./data/breadcrump-data";
import { useDiagnosisData } from "./hooks/useDiagnosisData";
import { IoIosArrowBack } from "react-icons/io";
import clsx from "clsx";

export default function DiagnosisPage() {
  // const { diagnosisData, isLoadingDiagnosisByCompany } = useDiagnosisData();
  const { diagnosisData } = useDiagnosisData();
  const dispatch = useAppDispatch();
  const current = useAppSelector((state) => state.util.diagnosisCurrent);

  const { corporateId, setCorporateId } = useCorporate();
  const { idCompany } = useParams();
  const [searchParams] = useSearchParams();
  const isCompanyInfoCollapse = useAppSelector(
    (state) => state.util.companyInfoCollapse,
  );

  const companyId = useMemo(
    () => parseInt(decryptId(idCompany ?? "")),
    [idCompany],
  );

  const corporateParamParsed = useMemo(() => {
    const corporateParam = searchParams.get("corporate");
    return corporateParam ? parseInt(decryptId(corporateParam)) : undefined;
  }, [searchParams]);

  const { data: companyById } = companyService.useFindByIdQuery(
    companyId ? { id: companyId } : skipToken,
  );

  const diagnosisDataStore = useAppSelector(
    (state) => state.diagnosis.diagnosis,
  );

  useEffect(() => {
    setCorporateId(corporateParamParsed);
  }, [corporateParamParsed, setCorporateId]);

  useEffect(() => {
    if (corporateId || companyById) {
      dispatch(setDiagnosisCurrent(diagnosisDataStore?.diagnosis_step ?? 0));
    }
  }, [corporateId, companyById, diagnosisDataStore?.diagnosis_step, dispatch]);
  const steps = useMemo(() => {
    const stepsArray = [
      {
        title: "Conteo",
        content: (
          <QuantityForm
            companyId={companyId}
            diagnosisId={diagnosisData?.diagnosis.id || 0}
          />
        ),
        icon:
          corporateId || current > 0 ? null : (
            <MdAccountTree className="text-black" />
          ),
        subTitle: "Aqui se define el nivel de complejidad",
        status: corporateId || current > 0 ? "finish" : "process",
      },
      {
        title: "Lista de Verificación",
        content: <DiagnosisForm companyId={companyId} />,
        icon: current > 1 ? null : <FaClipboardCheck />,
        status: current > 1 ? "finish" : "process",
        subTitle: "Cumplimiento de todos los items",
      },
      {
        title: "Informe",
        icon: <MdOutlineCloudDownload />,
        content: (
          <DownLoadReport
            companyId={companyId}
            secuence={diagnosisData?.diagnosis.sequence ?? ""}
            schedule={diagnosisData?.diagnosis.schedule ?? ""}
          />
        ),
        subTitle: "Generar el informe del diagnóstico",
      },
    ];

    return stepsArray;
  }, [companyId, diagnosisData, corporateId, current]);

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
    icon: item.icon,
    subTitle: item.subTitle,
  }));

  const validCurrent = current >= 0 && current < steps.length;

  useEffect(() => {
    dispatch(setStepsLenght(steps.length));
  }, [steps.length, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(fullResetDiagnosis());
    };
  }, [dispatch]);

  return (
    <div className="w-full flex flex-col ">
      <div className="p-4 flex items-center">
        <Breadcrumb
          className="flex items-center"
          separator="/"
          items={BreadcrumbItems}
        />
      </div>
      <Steps size="small" current={current} items={items} type="navigation" />
      <div className="mt-4 border-2 border-dashed rounded-xl p-2 relative transition-all">
        {current < 2 && (
          <span
            onClick={() => dispatch(setCompanyInfoCollapse())}
            className={clsx(
              "hidden md:flex absolute left-[31%] top-16 bg-black text-white border size-8 rounded-full z-10  justify-center items-center cursor-pointer hover:bg-zinc-800 transition",
              isCompanyInfoCollapse && "!left-0 !top-24  transition-all",
            )}
          >
            <IoIosArrowBack
              className={clsx(
                isCompanyInfoCollapse && "rotate-180",
                "transition",
              )}
            />
          </span>
        )}
        <div className="flex flex-col md:flex-row flex-1 justify-between items-start gap-4">
          {current != 2 && <CompanyInfo companyId={companyId} />}
          {validCurrent ? steps[current].content : null}
        </div>
      </div>
    </div>
  );
}
